import * as Yup from "yup";

import { TextManager } from "Components/TextContext";
import { CabinContentsCoverage } from "Store/interfaces/products/coverage";
import { CabinContentsProductPriceFormValues } from "../cabinContentsInterfaces";

export const validationSchema =
  (): Yup.ObjectSchema<CabinContentsProductPriceFormValues> => {
    const { getText } = TextManager;

    return Yup.object({
      deductible: Yup.string().required(
        getText("cabincontentsform.validation.deductible"),
      ),
      coverage: Yup.mixed<CabinContentsCoverage>().required(
        getText("cabincontentsform.validation.coverage"),
      ),
    }).defined();
  };
